module.exports = __webpack_public_path__ + "img/white.ac90b6be.svg";